window.CaffeNero = (function($, util, components) {
    window.dataLayer = window.dataLayer || [];
    let self = {
        state: {
            yoyoAuthCodeUrl: ''
        },
        elements: {
            buttons: {
                guardedButtons: '.guarded-button',
                complianceButtons: '.compliance-button',
                openDelinkModalButton: '#open-delink-modal-button'
            },
            ids: {
                refreshModal: 'nero-refresh-modal',
                successfulDelinkNotification: 'CAFFE_NERO_DE_LINK_COMPLETED'
            },
            classNames: {
                vdsNotification: 'vds-notification',
                vdsNotificationWithTopMargin: 'vds-notification--pre-desktop-margin-top'
            }
        },
        urls: {
            fetchAuthCode: '/api/sitecore/CoffeeSignUp/FetchAuthCode',
            enrolMember: '/api/sitecore/CoffeeSignUp/Enrol',
            errorPage: '/error/error-page'
        },
        func: {
            init: function() {
                self.func.bindings();
            },
            coffeeFeatureToggle: function(isToggleOn,inCoffeeLanding) {
                if(isToggleOn && inCoffeeLanding) {
                    $('.vds-main-content__primary-container>div').hide();
                    $('.vds-main-content__primary-container>section').hide();
                    $('.vds-content-block:first').show();
                    $('.vds-notification:first').show();
                    $('.vds-app-download-banner').parent().parent().addClass('vds-margin-top-touch-only');
                    $('.vds-partner-header:first').show();
                    $('.vds-wide-card:first').show();
                }
            },
            bindings: function() {
                $(components.ComplianceInformation.Elements.Buttons.SignUpButton)
                    .on('click', self.func.handleSignUpButtonClick);
                $(self.elements.buttons.openDelinkModalButton).on('click', self.func.pushOpenDelinkModalAnalytics);
            },
            padNotifications: function () {
                const notifications = $(`.${self.elements.classNames.vdsNotification}`);
                notifications.removeClass(self.elements.classNames.vdsNotificationWithTopMargin);
                notifications.first().addClass(self.elements.classNames.vdsNotificationWithTopMargin);
            },
            handleSignUpButtonClick: function() {
                if (components.ComplianceInformation.Func.IsSignUpButtonEnabled()) {
                    self.func.fetchAuthCode();
                    window.dataLayer.push({
                        event: self.gtm.event.ctaClick,
                        clickValue: self.gtm.clickValue.link
                    });
                    components.ComplianceInformation.Func.SwitchToPleaseWaitButton();
                }
            },
            fetchAuthCode: function() {
                $.ajax({
                    type: 'GET',
                    url: self.urls.fetchAuthCode,
                    success: self.func.fetchAuthCodeSuccess,
                    error: self.func.fetchAuthCodeError
                });
            },
            fetchAuthCodeSuccess: function(data) {
                self.state.yoyoAuthCodeUrl = data.yoyoAuthCodeUrl;
                window.dataLayer.push({
                    event: self.gtm.event.ctaClick,
                    clickValue: self.gtm.clickValue.activate
                });
                components.ComplianceInformation.Func.SwitchToRefreshButton();
                self.func.redirectToYoyo();
            },
            fetchAuthCodeError: function(jqxhr) {
                if (jqxhr.statusCode === util.httpStatusCodes.loginTimeout) {
                    util.func.reloadPage();
                } else {
                    self.func.redirectToErrorPage();
                }
            },
            redirectToYoyo: function() {
                util.func.redirect(self.state.yoyoAuthCodeUrl);
            },
            redirectToErrorPage: function() {
                util.func.redirect(self.urls.errorPage);
            },
            enrolMember: function() {
                const url = new URL(location.href);
                const code = url.searchParams.get('code');
                const state = url.searchParams.get('state');
                const error = url.searchParams.get('error');
                $.ajax({
                    type: 'POST',
                    url: self.urls.enrolMember,
                    data: { code: code, state: state, error: error },
                    success: self.func.enrolMemberSuccess,
                    error: self.func.enrolMemberError
                });
            },
            enrolMemberSuccess: function(data) {
                if (data.notificationCode == null) {
                    util.func.redirect(data.redirect);
                } else {
                    util.func.redirect(data.redirect, { notificationCode: data.notificationCode });
                }
            },
            enrolMemberError: function(jqxhr) {
                if (jqxhr.statusCode === util.httpStatusCodes.loginTimeout) {
                    util.func.reloadPage();
                } else {
                    self.func.redirectToErrorPage();
                }
            },
            pushOpenDelinkModalAnalytics: function() {
                window.dataLayer.push({
                    event: self.gtm.event.delink,
                    action: self.gtm.action.delinkAccount,
                    partner: self.gtm.partner.caffeNero
                });
            },
            pushDelinkAnalytics: function(notificationCode) {
                const eventObject = {
                    action: self.gtm.action.delinkAccount,
                    partner: self.gtm.partner.caffeNero
                };

                if (notificationCode === self.elements.ids.successfulDelinkNotification) {
                    eventObject.delinkResult = self.gtm.delinkResult.successful;
                } else {
                    eventObject.delinkResult = self.gtm.delinkResult.failure;
                    eventObject.errorMessage = notificationCode;
                }

                window.dataLayer.push(eventObject);
            }
        },
        gtm: {
            event: {
                ctaClick: 'ctaClick',
                delink: 'delink'
            },
            clickValue: {
                link: 'link-account',
                activate: 'activate'
            },
            action: {
                delinkAccount: 'delinkAccount'
            },
            partner: {
                caffeNero: 'caffeNero'
            },
            delinkResult: {
                successful: 'successful',
                failure: 'failure'
            }
        },
        getParameterByName: function(name, url) {
            const number = 2;
            let loUrl = url;
            let loName = name;
            if (!loUrl) {
                loUrl = window.location.href;
            }
            loName = loName.replace(/[\[\]]/g, '\\$&');
            const regex = new RegExp('[?&]' + loName + '(=([^&#]*)|&|#|$)'), results = regex.exec(loUrl);
            if (!results) {
                return null;
            }
            if (!results[number]) {
                return '';
            }
            return decodeURIComponent(results[number].replace(/\+/g, ' '));
        }
    };

    return {
        init: self.func.init,
        coffeeFeatureToggle:self.func.coffeeFeatureToggle,
        enrolMember: self.func.enrolMember,
        pushDelinkAnalytics: self.func.pushDelinkAnalytics,
        getParameterByName: self.getParameterByName,
        padNotifications: self.func.padNotifications
    };
})
(jQuery, window.Utilities, { ComplianceInformation: window.ComplianceInformation });


$('document').ready(function () {
    const pageData = $('#page-data');
    const inCoffeeFeature = 'coffee' === pageData.data('feature');
    const inCoffeeLanding = 'coffee-landing' === pageData.data('page');
    const onSignupPage = 'signup' === pageData.data('page');
    const onTrackingPage = 'tracking' === pageData.data('page');
    const onPendingPage = 'pending' === pageData.data('page');
    const afterDelinkAction = 'delink' === window.CaffeNero.getParameterByName('action');
    const normalPageMode = 'normal' === pageData.data('page-mode');

    if (inCoffeeFeature) {
        window.CaffeNero.init();
        const featureToggle = 'True' === pageData.data('feature-toggle');
        window.CaffeNero.coffeeFeatureToggle(featureToggle,inCoffeeLanding);
    }

    if (inCoffeeFeature && (onSignupPage || onTrackingPage)) {
        window.CaffeNero.padNotifications();
    }
    if (inCoffeeFeature && onPendingPage && normalPageMode) {
        window.CaffeNero.enrolMember();
    }
    if (inCoffeeFeature && afterDelinkAction) {
        window.CaffeNero.pushDelinkAnalytics(window.CaffeNero.getParameterByName('notificationCode'));
    }
});
